import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ShellService } from '@mynexus/mfe-core';
import { Observable } from 'rxjs';
import { ICoreAuthorizationDTO } from '@core/model';

@Injectable()
export abstract class SharedAuthorizationService {
  protected readonly API_URL;

  constructor(
    public http: HttpClient,
    protected shellService: ShellService,
    @Inject('stream') private readonly stream: string
  ) {
    this.API_URL = shellService.getBaseUrlFor(stream);
  }

  // We don't want the MFE to have awareness to any stream specific DTOs, so will bind to a generic object, where
  // each stream will have their own service that maps to Document.MFE's specific model.
  protected getAuthorization(tenantId: string, authorizationByProductId: string): Observable<object> {
    return this.http.get<object>(`${this.getBaseUrl(tenantId)}/authorizations/${authorizationByProductId}`);
  }

  protected getBaseUrl(tenantId: string): string {
    return `${this.API_URL}/tenants/${tenantId}`;
  }

  abstract mapAuthorizationDTO(authorizationDto: object): ICoreAuthorizationDTO;

  getAuthorizationProvidersSummary(tenantId: string,authorizationByProductId: string): Observable<object> {
    const url = `${this.API_URL}/tenants/${tenantId}/authorization/${authorizationByProductId}/providers/summary`;
    return this.http.get<object>(url);
  }

  getServiceLinesSummarybyAuthNumber(tenantId: string, authorizationNumber: string): Observable<any[]> {
    const url = `${this.API_URL}/tenants/${tenantId}/Authorizations/${authorizationNumber}/ServiceLines/summary`;
    return this.http.get<any[]>(url);
  }
}
